import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { SessionManager } from '../../session/service/session-manager';
import { CampaignId } from '../../module/campaign-util/shared/campaign-id';
import { HttpClient } from '@angular/common/http';
import { SessionTokenService } from '../../session/service/session-token';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GlobalEventBus } from '../../shared/event/global-bus';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as moment from 'moment-timezone';
import { TimezoneStorage } from '../../shared/misc/service/timezone-storage';
import { DeviceSizeService } from '../../shared/services/device-size.service';
import { DeviceSizes } from '../../shared/enum/device-size';

@Component({
  selector: 'admin-topbar',
  templateUrl: './admin-topbar.component.html',
  styleUrls: ['./admin-topbar.component.scss'],
})

export class AdminTopbarComponent implements OnInit, OnDestroy {

  routeChangeSubscription: Subscription;

  campaign: any = null;
  campaigns: any = [];
  user: any = {};
  hasAdminSession: boolean = false;
  timer: any;
  isOpen: boolean = false;
  isSidebarOpen: boolean = false;
  modalRef: BsModalRef;
  isSmallDevice = false;

  @Output()
  sidebarChanged = new EventEmitter<boolean>();

  constructor(private sessionManager: SessionManager,
              private sessionToken: SessionTokenService,
              private httpClient: HttpClient,
              private route: ActivatedRoute,
              private toastrService: ToastrService,
              private router: Router,
              private globalEventBus: GlobalEventBus,
              private deviceSize: DeviceSizeService) {
  }

  onClickMenu(event: Event) {
    event.preventDefault();
    this.isSidebarOpen = !this.isSidebarOpen;
    this.sidebarChanged.emit(this.isSidebarOpen);
  }

  onClick(event: Event) {
    event.preventDefault();
    this.isOpen = !this.isOpen;
  }

  ngOnInit() {
    this.hasAdminSession = !!this.sessionToken.getAdminToken();

    this.globalEventBus.bind('campaign:created', () => {
      this.load();
    });

    this.globalEventBus.bind('user:updated', () => {
      this.loadUser();
    });

    this.user.timezone = moment.tz.guess();
    this.load();
    this.loadUser();

    this.listenForDeviceSizeChange();
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
  }

  loadUser() {
    this.sessionManager.getIdentity()
      .subscribe((user: any) => {
        this.user = user;
        if (!this.user.timezone) {
          this.user.timezone = moment.tz.guess();
        }
      });
  }

  load(): Subscription {
    return null;
  }

  logout() {
    this.sessionManager.destroy();
  }

  listenForDeviceSizeChange(): void {
    // Method takes DeviceSize from service and compare with enums which we are interested in,
    // then set variable to specific boolean value - use in GoPhoto logo displaying
    this.deviceSize.deviceSize$.subscribe((deviceSize) => {
      if ((deviceSize === DeviceSizes.mobile) ||
        (deviceSize === DeviceSizes.largeMobile) ||
        (deviceSize === DeviceSizes.tablet)
      ) {
        this.isSmallDevice = true;
      } else {
        this.isSmallDevice = false;
      }
    });
  }
}
